/**
 * Branch wording for the QR / SMS registration pages.
 *
 * Each text is editable per branch in the text editor; an empty value falls
 * back to the built-in default below.
 */
import { useEffect, useState } from "react";
import { getServiceSettings } from "../../../api/api";

export const CUSTOMER_FLOW_TEXT_DEFAULTS = {
    qr_scan_text: "Scan QR-koden for å registrere deg i køen!",
    sms_phone_text: "Legg inn mobilnummeret for å registrere deg i køen!",
    sms_register_button_text: "Registrer deg i køen!",
    sms_confirmation_text: "Du har fått kønummer!",
    sms_new_queue_button_text: "REGISTRER DEG I KØEN",
    being_served_message: "Du blir nå betjent!",
};

const useCustomerFlowTexts = (branchId) => {
    const [texts, setTexts] = useState(CUSTOMER_FLOW_TEXT_DEFAULTS);

    useEffect(() => {
        if (!branchId) return;
        let cancelled = false;

        const fetchTexts = async () => {
            try {
                const response = await getServiceSettings(branchId);
                if (cancelled || !response?.success) return;

                const merged = { ...CUSTOMER_FLOW_TEXT_DEFAULTS };
                Object.keys(merged).forEach((key) => {
                    if (response.data?.[key]) merged[key] = response.data[key];
                });
                setTexts(merged);
            } catch (err) {
                console.error("Failed to load customer flow texts", err);
            }
        };

        fetchTexts();
        return () => {
            cancelled = true;
        };
    }, [branchId]);

    return texts;
};

export default useCustomerFlowTexts;
